import { render, staticRenderFns } from "./NewRegistrationComplete.vue?vue&type=template&id=3574c45b&scoped=true&"
import script from "./NewRegistrationComplete.vue?vue&type=script&lang=js&"
export * from "./NewRegistrationComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3574c45b",
  null
  
)

export default component.exports